import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import CarePlanService from '@/services/CarePlanService';
import type { CarePlan } from '@/services/CarePlanService';
import { CARE_PLAN_KEYS } from './keys';

export function useCarePlans() {
  return useQuery({
    queryKey: CARE_PLAN_KEYS.list(),
    queryFn: () => CarePlanService.getCarePlans(),
  });
}

export function useCarePlanByUser(userid: string | number | null | undefined) {
  return useQuery({
    queryKey: CARE_PLAN_KEYS.byUser(userid ?? ''),
    queryFn: () => CarePlanService.getCarePlanByUser(userid!),
    enabled: userid != null && userid !== '',
  });
}

// Imperative one-shot — fetch the current care plan via the cache.
export function useFetchCarePlanByUser() {
  const qc = useQueryClient();
  return useCallback(
    (userid: string | number) => qc.fetchQuery({
      queryKey: CARE_PLAN_KEYS.byUser(userid),
      queryFn: () => CarePlanService.getCarePlanByUser(userid),
    }),
    [qc],
  );
}

export type { CarePlan };
